import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import React from 'react';

export default function StandardModal({
  children,
  title,
  show,
  closeHandler,
  acceptHandler,
  showButtons = true,
  className = '',
  buttonVarient = 'error',
  acceptName = 'Archive',
  closeName = 'Cancel',
  cancelClassName = '',
  buttons = 'normal',
  isForm,
  scrollBehavior = 'normal',
  size = '2xl',
  footerContent,
  isLoading = false,
  isDisabled = false,
  backdrop = 'transparent',
  bodyClassName,
  contentClassName,
  headerClassName,
}: {
  children: React.ReactNode;
  title: React.ReactNode;
  show: boolean;
  closeHandler: () => void | (() => Promise<void>);
  acceptHandler?: any;
  showButtons?: boolean;
  className?: string;
  buttonVarient?: 'error' | 'accept';
  acceptName?: string;
  closeName?: string;
  cancelClassName?: string;
  buttons?: 'normal' | 'big';
  isForm?: string;
  scrollBehavior?: 'normal' | 'inside' | 'outside';
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | 'full';
  footerContent?: React.ReactNode;
  isLoading?: boolean;
  isDisabled?: boolean;
  backdrop?: 'transparent' | 'opaque' | 'blur';
  bodyClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
}) {
  // const body = (
  //   <>
  //     {children}
  //     {showButtons && (
  //       <div className='mt-6 flex justify-end gap-2'>
  //         <button
  //           className={`btn-outline ${
  //             buttons === 'normal' ? 'btn-sm' : 'btn-md'
  //           } btn ${buttonVarient === 'error' ? '' : 'btn-error'}`}
  //           onClick={closeHandler}
  //         >
  //           {closeName}
  //         </button>
  //         {acceptHandler && (
  //           <button
  //             type='submit'
  //             className={`${
  //               buttonVarient === 'error' ? 'btn-error' : 'btn-success'
  //             } ${buttons === 'normal' ? 'btn-sm' : 'btn-md'} btn`}
  //             onClick={isForm ? undefined : acceptHandler}
  //             style={{ minWidth: 100 }}
  //           >
  //             {acceptName}
  //           </button>
  //         )}
  //       </div>
  //     )}
  //   </>
  // );

  return (
    // <div
    //   className={`modal !bg-slate-400/10  ${show ? 'modal-open' : ''}`}
    //   id='modal-id'
    // >
    //   <div
    //     className={`modal-box overflow-visible border border-themeBlack bg-base-100/30 backdrop-blur-md ${className}`}
    //   >
    //     <button
    //       className='btn btn-circle btn-ghost btn-sm absolute right-2 top-2'
    //       onClick={closeHandler}
    //     >
    //       ✕
    //     </button>
    //     <h4 className='pb-4 font-bold'>{title}</h4>
    //     <hr className='mb-4' />
    //     {isForm ? <form onSubmit={acceptHandler}>{body}</form> : body}
    //   </div>
    //   <label className='modal-backdrop' onClick={closeHandler}>
    //     Close
    //   </label>
    // </div>
    <Modal
      isOpen={show}
      onClose={closeHandler}
      size={size}
      className={
        backdrop === 'transparent'
          ? `border border-gray-400 bg-base-100/50 backdrop-blur-md ${className} standard-modal`
          : `border border-gray-200 bg-white shadow-xl ${className} standard-modal`
      }
      classNames={{
        base: 'sm:!ml-24',
        wrapper:
          size === 'full'
            ? 'z-[1000] h-[100dvh] max-h-[100dvh] overflow-hidden p-0 items-stretch'
            : 'z-[1000] overflow-visible',
        backdrop: backdrop === 'opaque' ? 'bg-black/50' : undefined,
      }}
      backdrop={backdrop}
      scrollBehavior={scrollBehavior}
    >
      <ModalContent
        className={
          contentClassName ??
          (size === 'full' ? 'flex h-full min-h-0 flex-col' : undefined)
        }
      >
        {() => (
          <>
            <ModalHeader className={headerClassName}>{title}</ModalHeader>
            {/* scoped style: remove focus ring on modal header close button to avoid blue circle when interacting with inputs inside the modal */}
            <ModalBody
              className={
                bodyClassName ??
                'max-h-[80vh] overflow-visible overflow-y-auto overflow-x-visible py-1'
              }
            >
              {children}
            </ModalBody>
            {showButtons && (
              <ModalFooter className='mt-4 items-center'>
                <div className='grow items-start'>
                  {footerContent && footerContent}
                </div>

                <div className='flex items-center justify-end gap-2'>
                  <Button
                    variant='bordered'
                    color={buttonVarient === 'error' ? 'default' : 'danger'}
                    size={buttons === 'normal' ? 'sm' : 'md'}
                    onPress={closeHandler}
                    className={`${cancelClassName} border font-bold uppercase`}
                  >
                    {closeName}
                  </Button>

                  {(acceptHandler || isForm) && (
                    <Button
                      form={isForm}
                      type='submit'
                      variant='solid'
                      color={buttonVarient === 'error' ? 'danger' : 'success'}
                      size={buttons === 'normal' ? 'sm' : 'md'}
                      onPress={isForm ? undefined : acceptHandler}
                      className='min-w-[80px] font-bold uppercase'
                      isLoading={isLoading}
                      isDisabled={isDisabled}
                    >
                      {acceptName}
                    </Button>
                  )}
                </div>
              </ModalFooter>
            )}
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
